<template>
  <div>
    <trip-config-form :is-new="false" />
  </div>
</template>

<script>
import TripConfigForm from '../components/TripConfigForm.vue'

export default {
  components: {
    TripConfigForm,
  },
}
</script>

<style>

</style>
